module.exports = __webpack_public_path__ + "img/development_02.90c03320.png";